export interface NavItem {
  label: string;
  href: string;
  children?: NavItem[];
}

export const navigationItems: NavItem[] = [
  {
    label: 'Versicherungen',
    href: '/versicherungen',
    children: [
      { label: 'Das Wichtigste in Kürze', href: '/versicherungen' },
      { label: 'Krankenversicherung', href: '/versicherungen/krankenversicherung' },
      { label: 'Berufsunfähigkeitsversicherung', href: '/versicherungen/berufsunfaehigkeit' },
      { label: 'Haftpflichtversicherung', href: '/versicherungen/haftpflicht' },
      { label: 'Sonstige Versicherungen', href: '/versicherungen/sonstige' },
    ],
  },
  {
    label: 'Altersvorsorge',
    href: '/altersvorsorge',
    children: [
      { label: 'Das Wichtigste in Kürze', href: '/altersvorsorge/ueberblick' },
      { label: 'Versorgungswerk & Rentenversicherung', href: '/altersvorsorge/versorgungswerk' },
      { label: 'NEU ab 2027: Altersvorsorgedepot', href: '/altersvorsorge/altersvorsorgedepot' },
      { label: 'Private Vorsorge', href: '/altersvorsorge/private-vorsorge' },
      { label: 'Betriebliche Altersvorsorge', href: '/altersvorsorge/betriebliche' },
      { label: 'Riester Rente', href: '/altersvorsorge/riester' },
      { label: 'Basis Rente', href: '/altersvorsorge/basis' },
      { label: 'Vergleichsrechner', href: '/altersvorsorge/vergleichsrechner' },
      
    ],
  },
  {
    label: 'Investment',
    href: '/investment',
    children: [
      { label: 'Das Wichtigste in Kürze', href: '/investment/ueberblick' },
      { label: 'Giro-, Tagesgeld- & Festgeldkonto', href: '/investment/konten' },
      { label: 'ETFs, Fonds & Aktien', href: '/investment/etfs-fonds-aktien' },
      { label: 'Immobilien', href: '/investment/immobilien' },
      { label: 'Vermögenswirksame Leistungen', href: '/investment/vl' },
    ],
  },
  {
    label: 'Beiträge',
    href: '/beitraege',
  },
  {
    label: 'Über uns',
    href: '/ueber-uns',
  },

  {
    label: 'Beratung',
    href: '/beratung',
    children: [
      { label: 'Individuelle Beratung', href: '/beratung/individuell' },
      { label: 'Online Seminare', href: '/beratung/seminare' },
    ],
  },
];
